// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__29zrk","tab":"ProcedureTabs_tab__1fOit"};